/*
 * Public API Surface of microapp-home
 */


export * from './lib/microapp-faultreport.module';
export * from './pages/microapp-faultreport.home.component';
export * from './pages/microapp-faultreport.home.module';
